import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { usePageContentQuery } from 'enrollment/queries/usePageContentQuery';
import { PAGE_CONTENT_LOOKUP_CODE } from './utils';
import { PageContent } from './PageContentWrapper';
import { DrawerWrapperStyled } from 'enrollment/features/Plans/PlanDetailsDrawer/PlanDetailsDrawerStyled';
import { PsDrawerDialog } from 'stencilSetup';

export interface PageContentDetailsProps {
  pageContentLookup: string;
  orgPlanYear: number;
  orgPlans?: string[];
  benefitLookup: string;
  benefitName?: string;
}

export const PageContentDetails = ({
  pageContentLookup,
  orgPlanYear,
  orgPlans,
  benefitLookup,
  benefitName,
}: PageContentDetailsProps) => {
  const { t } = useTranslation();
  const [queryEnabled, setQueryEnabled] = useState<boolean>(false);

  const { pageContent } = usePageContentQuery({
    pageContentLookupCode: PAGE_CONTENT_LOOKUP_CODE[pageContentLookup],
    orgPlanYearId: orgPlanYear,
    benefitLookupCode: benefitLookup,
    orgPlanIds: orgPlans ? orgPlans.toString() : '',
    enabled: queryEnabled,
  });

  const handleClick = () => {
    const infoDialog = document.querySelector(
      `#pc_${benefitLookup}_${orgPlanYear}_drawer`
    );
    document.dispatchEvent(
      new CustomEvent('psOpenDialog', { detail: infoDialog })
    );
    setQueryEnabled(true);
  };

  return (
    <DrawerWrapperStyled
      data-testid={`${benefitLookup}_${orgPlanYear}_page_content_container`}
      id={`pc_${benefitLookup}_${orgPlanYear}_page_content_container`}
    >
      <ps-button
        data-testid={`${benefitLookup}_${orgPlanYear}_page_content_drawer_trigger`}
        id={`pc_${benefitLookup}_${orgPlanYear}_page_content_drawer_trigger`}
        label={t('LearnMore')}
        level="secondary"
        extraClass="btn-link"
        onClick={handleClick}
        {...(benefitName
          ? { otherData: `aria-describedby=${benefitName}` }
          : {})}
      ></ps-button>
      <PsDrawerDialog
        dialogId={`pc_${benefitLookup}_${orgPlanYear}_drawer`}
        dialogTriggerClass="btn-link"
        dialogLarge
        dialogTriggerLink
      >
        <div>
          <PageContent pageContent={pageContent} />
        </div>
      </PsDrawerDialog>
    </DrawerWrapperStyled>
  );
};
